module.exports = __webpack_public_path__ + "fonts/k3k702ZOKiLJc3WVjuplzBampu5_7CjHW5spxoeN3Vs.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/k3k702ZOKiLJc3WVjuplzBampu5_7CjHW5spxoeN3Vs.woff2
// module id = 398
// module chunks = 0